<!--
 * @Name: login
 * @Description: 登录
 * @Author: xiadongxue
 * @Date: 2021-10-19 11:39:52
 * @Editors: xiadongxue
-->
<template>
<div class="login-wrap">
    <div class="left">
        <img src="/login_logo.png" alt class="logo" />
        <span class="logo-name">钛核互动</span>
        <span class="logo-slogon">因梦想 而相聚</span>
    </div>
    <div class="login-container">
        <div class="form-container">
            <div class="steps-wrap" v-if="!reset && !isDev">
                <div class="finish" @click="loginActive = 1"></div>
                <div :class="{'finish': loginActive >= 2}"></div>
            </div>
            <div class="title">{{reset ? '重置密码' : '后台系统 SSO 登录'}}</div>
            <template v-if="!reset">
                <el-form
                    v-loading="stepsLoading"
                    ref="loginForm"
                    :model="loginForm"
                    :rules="loginRules">
                    <!--登录第一步-->
                    <div v-show="loginActive === 1">
                        <div class="form-item">
                            <i class="user_icon svg-icon"></i>
                            <el-form-item prop="account">
                                <el-input
                                    clearable
                                    placeholder="请输入邮箱"
                                    @keydown.enter.native="login"
                                    v-model="loginForm.account">
                                    <template slot="append">
                                        <el-select v-model="emailSuffix">
                                            <el-option
                                                v-for="item in emailList"
                                                :key="item.emailSuffix"
                                                :value="item.emailSuffix"
                                                :label="item.emailSuffix"></el-option>
                                        </el-select>
                                    </template>
                                </el-input>
                            </el-form-item>
                        </div>
                        <div class="form-item">
                            <i class="pwd_icon svg-icon"></i>
                            <el-form-item prop="password">
                                <el-input
                                    clearable
                                    @keydown.enter.native="login"
                                    placeholder="请输入密码"
                                    v-model="loginForm.password"
                                    show-password
                                    type="password"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <!--登录第二步-->
                    <div
                        class="form-item"
                        v-show="loginActive === 2">
                        <i class="code_icon svg-icon"></i>
                        <el-form-item prop="code">
                            <el-input
                                :class="{'code-input': loginForm.loginType === 0}"
                                clearable
                                @keydown.enter.native="login"
                                placeholder="请输入验证码"
                                v-model="loginForm.code"></el-input>
                        </el-form-item>
                        <template v-if="loginForm.loginType === 0">
                            <span v-if="!isSendCode" class="code-btn" @click="toSendCode">发送</span>
                            <span v-else class="code-btn">{{count}}s</span>
                        </template>
                    </div>
                    <div class="form-item" v-show="isDev || (!isDev && loginActive === 2)">
                        <div class="checkbox-wrap">
                            <el-checkbox v-model="loginForm.rememberMe">7天免登录</el-checkbox>
                        </div>
                    </div>
                    <template v-if="!isDev">
                        <el-button
                            v-show="loginActive === 1"
                            type="danger"
                            @click="login">继续</el-button>
                        <el-button
                            v-show="loginActive === 2"
                            type="danger"
                            @click="login">登录</el-button>
                    </template>
                    <el-button
                        v-else
                        type="danger"
                        @click="login">登录</el-button>
                    <div class="reset-pwd reset" v-if="isDev || loginActive === 1">
                        <span @click="toReg">申请账号</span>
                        <span @click="toSendEmail">忘记密码</span>
                    </div>
                </el-form>
            </template>
            <template v-else>
                <el-form
                    ref="resetForm"
                    :model="resetForm"
                    :rules="resetRules">
                    <div class="form-item">
                        <i class="user_icon svg-icon"></i>
                        <el-form-item prop="account">
                            <el-input
                                disabled
                                clearable
                                placeholder="请输入邮箱"
                                v-model="resetForm.account"></el-input>
                        </el-form-item>
                    </div>
                    <div class="form-item">
                        <i class="pwd_icon svg-icon"></i>
                        <el-form-item prop="newPwd">
                            <pwd-warn :pwd.sync="resetForm.newPwd" />
                        </el-form-item>
                    </div>
                    <div class="form-item">
                        <i class="pwd_again_icon svg-icon"></i>
                        <el-form-item prop="confirmPwd">
                            <el-input
                                clearable
                                v-model="resetForm.confirmPwd"
                                show-password
                                placeholder="请再次输入密码"
                                type="password"></el-input>
                        </el-form-item>
                    </div>
                    <el-button
                        type="danger"
                        @click="resetToLogin">确认</el-button>
                    <div class="reset-pwd">
                        <span @click="resetToLogin(true)">去登录</span>
                    </div>
                </el-form>
            </template>
        </div>
    </div>
</div>
</template>

<script>
import {
    toLogin,
    forgetPwd,
    resetPwd,
    auth,
    getSmsCode,
    preLogin,
    checkLoginSAML,
    checkLoginCAS
} from '@/api'
import {
    emailList
} from './manage/api'
import {
    getUrlParam,
    createTag
} from '@/assets/js/utils'
import PwdWarn from '@/components/PwdWarn'
export default {
    name: 'login',
    data() {
        return {
            //密码重置
            reset: this.$route.query.reset || false,
            isDev: CONFIG.baseUrl.indexOf('-dev.') !== -1,
            //忘记密码发送验证码
            isSendEmail: false,
            //发送验证码
            isSendCode: false,
            //倒计时
            count: 30,
            //验证码loading
            stepsLoading: false,
            //登录步骤
            loginActive: 1,
            //登录form
            loginForm: {
                //用户名
                account: '',
                //密码
                password: '',
                //验证码
                code: '',
                //7日免登陆
                rememberMe: false,
                //验证方式
                loginType: 1
            },
            emailList: [],
            emailSuffix: '@taiyouxi.cn',
            //重置form
            resetForm: {
                confirmPwd: '',
                newPwd: '',
                code: this.$route.query.code || '',
                account: this.$route.query.account || ''
            },
            loginRules: {
                account: [{
                    required: true,
                    message: "请输入",
                    trigger: 'change'
                }, {
                    pattern: /^[a-z0-9.-]+$/i,
                    message: '只能输入大小写字母与数字'
                }],
                password: [{
                    required: true,
                    message: "请输入",
                    trigger: 'change'
                }],
                code: [{
                    trigger: 'change',
                    validator: (rule, value, callback) => {
                        if (!this.isDev && this.loginActive === 2 && !value) {
                            callback(new Error('请输入'));
                        } else {
                            callback();
                        }
                    }
                }]
            },
            resetRules: {
                account: [{
                    required: true,
                    message: "请输入",
                    trigger: 'change'
                }],
                newPwd: [{
                    required: true,
                    message: "请输入",
                    trigger: 'change'
                }, {
                    pattern: /(?=.{8,})/,
                    message: "请输入至少8个字符",
                    trigger: 'submit'
                }, {
                    pattern: /(?=.*[A-Z]{1,})(?=.*[a-z]{1,})/,
                    message: "请输入包含大写与小写字母",
                    trigger: 'submit'
                }, {
                    pattern: /(?=.*\d)/,
                    message: "请输入至少1个数字",
                    trigger: 'submit'
                }, {
                    pattern: /^[^\s]*$/,
                    message: "不能输入空格",
                    trigger: 'submit'
                }],
                confirmPwd: [{
                    required: true,
                    message: "请输入"
                }, {
                    validator: (rule, value, callback) => {
                        if (value !== this.resetForm.newPwd) {
                            callback(new Error('密码不一致'));
                        } else {
                            callback();
                        }
                    }
                }]
            }
        };
    },
    components: {
        PwdWarn
    },
    computed: {
        //子系统
        isChild() {
            return (getUrlParam().clientId || getUrlParam().client_id) && (getUrlParam().redirectUri || getUrlParam().redirect_uri) ? true : false
        },
        //第三方登录
        isThird() {
            return this.$route.query.SAMLRequest || this.$route.query.service ? true : false
        },
        //重定向是否含有参数
        hasParam() {
            return this.redirectUrl.split('?').length > 1
        },
        isCas() {
            return this.$route.query.service ? true : false
        },
        redirectUrl() {
            return decodeURIComponent(this.$route.query.redirectUri || this.$route.query.redirect_uri)
        }
    },
    created() {
        if (this.$route.query.account) {
            let arr = this.$route.query.account.split('@')
            this.loginForm.account = arr[0]
            this.emailSuffix = '@' + arr[1]
        }
        //子系统登录
        if (this.isChild) {
            this.defaultLogin()
        }
        //三方登录
        if (this.isThird) {
            this.thirdLogin()
        }
        this.toGetEmail()
    },
    methods: {
        //获取邮箱后缀
        async toGetEmail() {
            let {
                code,
                result
            } = await emailList({
                enabled: 1
            })
            if (code === 0) {
                this.emailList = result
            }
        },
        //静默登录
        async defaultLogin() {
            try {
                let {
                    code,
                    result
                } = await auth({
                    clientId: this.$route.query.clientId || this.$route.query.client_id,
                    redirectUri: this.redirectUrl,
                })
                if (code === 0 && result && this.isChild) {
                    if (result.code) {
                        window.location.href = `${this.redirectUrl}${this.hasParam ? '&' : '?'}code=${result.code}${getUrlParam().state ? ('&state='+ getUrlParam().state) : ''}`
                    }
                }
            } catch (error) {
                console.log(error)
            }
        },
        //登录第一步
        async toPreLogin() {
            try {
                this.stepsLoading = true
                let { result,code } = await preLogin({
                    account: this.loginForm.account,
                    password: this.loginForm.password
                })
                if(code === 0) {
                    let loginType = result.loginType
                    this.loginForm.loginType = loginType
                    let text = loginType === 2 ? '请输入google验证码' : `已发送${loginType === 1 ? '邮件' : '短信'}，请查收`
                    this.$message.success(text)
                    this.loginActive = 2
                    if(loginType === 0) {
                        this.isSendCode = true
                        let interval = setInterval(() => {
                            this.count -= 1
                            if (this.count < 0) {
                                this.isSendCode = false
                                this.count = 30
                                clearInterval(interval)
                            }
                        }, 1000)
                    }
                }
                this.stepsLoading = false
            } catch (error) {
               console.log(error) 
            }
        },
        //登录校验
        login() {
            this.$refs['loginForm'].validate((valid) => {
                if (valid) {
                    //非开发环境第一步
                    if(!this.isDev && this.loginActive === 1) {
                        this.toPreLogin()
                        return
                    }
                    //第二步或者开发环境
                    if(this.loginActive === 2 || this.isDev) {
                        this.toGoLogin()
                        return
                    }
                } else {
                    return false;
                }
            });
        },
        //sso登陆
        async toGoLogin() {
            try {
                this.stepsLoading = true
                //通过校验
                let data = Object.assign({}, this.loginForm)
                data.account = this.loginForm.account + this.emailSuffix
                //子系统登录
                if (this.isChild) {
                    data = {
                        ...data,
                        clientId: this.$route.query.clientId || this.$route.query.client_id,
                        redirectUri: this.redirectUrl
                    }
                }
                let {
                    result,
                    code
                } = await toLogin(data)
                if (code === 0) {
                    //存储登录token
                    localStorage.setItem('token', JSON.stringify(result.token))
                    localStorage.setItem("user_login", true)
                    //子系统登录后跳转回redirectUri
                    if (this.isChild) {
                        window.location.href = `${this.redirectUrl}${this.hasParam ? '&' : '?'}code=${result.code}${getUrlParam().state ? ('&state='+ getUrlParam().state) : ''}`
                        //http://sso-dev.taiyouxi.cn:8080/login?redirectUri=http://console-gms-local.taiyouxi.cn:8081/&clientId=gms
                    } else if (this.isThird) {
                        //第三方登录
                        let param = `account=${data.account}&password=${encodeURIComponent(data.password)}&code=${data.code}&rememberMe=${data.rememberMe}`
                        let host = `${CONFIG.baseUrl}server/saml2/login`
                        if(this.isCas) {
                            host = `${CONFIG.baseUrl}server/cas/login`
                        }
                        window.location.href = `${host}?${param}&${window.location.href.split('?')[1]}`
                    } else {
                        this.$store.dispatch("userLogin", true)
                    }
                }
                this.stepsLoading = false
            } catch (error) {
                console.log(error)
            }
        },
        //登录验证码
        async toSendCode() {
            try {
                if (this.isSendCode) {
                    return
                }
                this.isSendCode = true
                let {
                    code,
                    result
                } = await getSmsCode({
                    account: this.loginForm.account + this.emailSuffix
                })
                if (code === 0) {
                    let interval = setInterval(() => {
                        this.count -= 1
                        if (this.count < 0) {
                            this.isSendCode = false
                            this.count = 30
                            clearInterval(interval)
                        }
                    }, 1000)
                    this.$message.success(`已发送${result.type == 0 ? '短信' : '邮件'}，请查收`)
                } else {
                    this.isSendCode = false
                }
            } catch (error) {
                this.isSendCode = false
                console.log(error)
            }
        },
        //忘记密码发送验证码
        async toSendEmail() {
            try {
                if (this.isSendEmail) {
                    return
                }
                if (!this.loginForm.account) {
                    this.$message.error('请输入邮箱')
                    return
                }
                this.isSendEmail = true
                let {
                    code
                } = await forgetPwd({
                    account: this.loginForm.account + this.emailSuffix
                })
                if (code === 0) {
                    this.$message.success('已发送邮件，请前去邮箱查看')
                }
                this.isSendEmail = false
            } catch (error) {
                console.log(error)
            }
        },
        /**
         * @description: 重置确认 || 去登陆
         * @param {Boolean} true 去登陆
         */
        //重置校验
        resetToLogin(flag) {
            //重置确认逻辑
            if (flag === true) {
                this.reset = false
                this.$nextTick(() => {
                    this.$refs['loginForm'].clearValidate()
                })
                return
            }
            this.$refs['resetForm'].validate((valid) => {
                if (valid) {
                    this.toReset()
                } else {
                    return false
                }
            })
        },
        //去重置
        async toReset() {
            try {
                let {
                    code
                } = await resetPwd(this.resetForm)
                if (code === 0) {
                    this.reset = false
                }
            } catch (error) {
                console.log(error)
            }
        },
        //去注册
        toReg() {
            createTag('http://confluence.taiyouxi.net/pages/viewpage.action?pageId=50368031')
        },
        //sso已登录跳转第三方
        async thirdLogin() {
            try {
                let Fn = checkLoginSAML
                if(this.isCas) {
                    Fn = checkLoginCAS
                }
                let {
                    code
                } = await Fn(getUrlParam())
                if (code === 0) {
                    let host = `${CONFIG.baseUrl}server/saml2/auth`
                    if(this.isCas) {
                        host = `${CONFIG.baseUrl}server/cas/auth`
                    }
                    window.location.href = `${host}?${window.location.href.split('?')[1]}`
                }
            } catch (error) {
                console.log(error)
            }
        }
    }
};
</script>

<style lang="scss">
.login-wrap {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    background-image: -webkit-linear-gradient(#fff 50%, #b62519 50%, #b62519 70%, #b62519);

    .el-button--danger:not(.is-disabled) {
        background-color: #b62519;
        border-color: #b62519;
    }

    .el-button--danger.is-disabled {
        background-color: rgba(182, 37, 25, .5);
        border-color: rgba(182, 37, 25, .1);
    }

    .el-checkbox {
        .el-checkbox__label {
            color: #9095A2;
        }

        &.is-checked {
            .el-checkbox__inner {
                background-color: #b62519;
                border-color: #b62519;
            }

            .el-checkbox__label {
                color: #b62519;
            }
        }
    }

    .left {
        .logo {
            position: absolute;
            width: 240px;
            height: 240px;
            left: 50%;
            top: 50%;
            margin-top: -300px;
            margin-left: -350px;
        }

        .logo-name {
            position: absolute;
            width: 300px;
            left: 50%;
            margin-left: -350px;
            text-align: left;
            top: 50%;
            margin-top: -30px;
            font-size: 20px;
            font-weight: bolder;
            color: #b62519;
        }

        .logo-slogon {
            position: absolute;
            width: 300px;
            left: 50%;
            margin-left: -350px;
            text-align: left;
            top: 50%;
            margin-top: 10px;
            color: #fff;
            font-size: 16px;
            letter-spacing: 10px;
        }
    }

    .login-container {
        position: absolute;
        left: 50%;
        margin-top: -200px;
        top: 50%;

        .form-container {
            width: 400px;
            min-width: 400px;
            text-align: center;
            box-shadow: 1px 1px 10px #888888;
            min-height: 260px;
            background-color: #fff;

            .steps-wrap {
                width: 100%;
                height: 6px;
                margin-bottom: 15px;
                display: flex;
                justify-content: space-between;

                div {
                    height: 100%;
                    width: 50%;
                    background: #F5F7FA;
                    &:first-child {
                        cursor: pointer;
                    }

                    &.finish {
                        background: #b62519;
                    }
                }
            }

            .title {
                padding-top: 10px;
                font-size: 18px;
                color: #b62519;
                margin-bottom: 20px;
                font-weight: bold;
            }

            .form-item {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 20px;

                .el-form-item {
                    margin-bottom: 0;
                }

                .svg-icon {
                    width: 30px;
                    height: 30px;
                    margin-right: 5px;
                }

                .code_icon {
                    width: 20px;
                    margin-left: 3px;
                    padding-right: 7px;
                    height: 26px;
                }

                .el-input {
                    width: 260px;
                }

                .el-input-group__append {
                    width: 120px;
                    padding: 0;

                    .el-select {
                        width: 100%;

                        .el-input {
                            width: 100%;

                            .el-input__inner {
                                padding-left: 5px;
                            }
                        }
                    }
                }

                .code-input {
                    width: 220px;
                }

                .code-btn {
                    width: 40px;
                    text-align: right;
                    color: #b62519;
                    cursor: pointer;
                }

                .code-wrap {
                    position: relative;
                }

                .checkbox-wrap {
                    width: 295px;
                    text-align: right;
                }

                .second {
                    position: absolute;
                    width: 40px;
                    top: 0;
                    right: 0;
                    line-height: 40px;
                    color: #b62519;
                    cursor: pointer;
                }

                .second.disabled {
                    cursor: not-allowed;
                }
            }

            .reset-pwd {
                transform: translateY(-10px);
                text-align: right;
                padding: 0 60px;
                color: #b62519;

                &.reset {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                }

                span {
                    cursor: pointer;
                }
            }

            .el-button {
                width: 300px;
                margin-bottom: 20px;
            }
        }
    }
}
</style>
